import {
  enhanceWrapped,
  InputBase,
} from '../../../../../configure/components/InputBase';

const INPUT_LABEL = 'Subscribe Button text';
const INPUT_PLACEHOLDER = '☑️ No';
const FIELD_TO_UPDATE = 'subscribeButtonText';

const enhance = enhanceWrapped(FIELD_TO_UPDATE, INPUT_LABEL, INPUT_PLACEHOLDER);
const SubscribeButtonText = enhance(InputBase);

export default SubscribeButtonText;
